import "./PaymentTermsV2.scss";
import React from "react";
import {observer} from "mobx-react-lite";
import {generatePath, Outlet} from "react-router";
import {MainPageFacade} from "~/components/main/page/MainPageFacade.tsx";
import {CARD_CONFIG} from "~/components/dashboard/DashboardCardConfigs.tsx";
import {useStores} from "~/stores";
import {routes} from "~/routing/routes.ts";
import type {PtV2OutletContext} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Context.ts";
import type {PtV2TabKey} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Classes.ts";
import {
    usePaymentTermsV2DatabagId,
    usePtV2SummaryQuery,
} from "~/experiments/pages/payment-terms-v2/usePaymentTermsV2Queries.ts";

/** Page shell: the title, then the active tab (KPIs, tabs, summary, content). Data management lives on Data sources. */
export const PaymentTermsV2Page: React.FC = observer(() => {
    const {authStore} = useStores();
    const databagId = usePaymentTermsV2DatabagId();
    const summaryQ = usePtV2SummaryQuery();

    const context: PtV2OutletContext = {
        summary: summaryQ.data,
        summaryLoading: summaryQ.isPending,
        summaryError: summaryQ.isError,
        hasData: Boolean(summaryQ.data?.lastImport),
        isStaff: authStore.isMithraStaffGroup,
        tabPath: (tab: PtV2TabKey) => `${generatePath(routes.payment_terms_v2, {id: String(databagId ?? '')})}/${tab}`,
    };

    const card = CARD_CONFIG['payment-terms-v2'];
    return <MainPageFacade
        title={card.title}
        titleTag={card.tag}
        className="payment-terms-v2-page">
        <Outlet context={context}/>
    </MainPageFacade>;
});
